<form #form="ngForm" (ngSubmit)="save(form)">
  <p-message severity="error" text="{{errorMessage}}" *ngIf="errorMessage"></p-message>
  <div class="p-fluid p-formgrid-del p-grid p-mt-0">
    <div class="p-field p-col-12 p-md-12 p-mb-0">
      <span class="p-float-label">
        <input pInputText 
              id="title" name="title"
              class="p-inputtext-sm"
              [(ngModel)]="rosterType.title" />
        <label for="title">Title</label>
      </span>
    </div>

    <!--Roster Pattern-->
    <div class="p-field p-col-12 p-md-12 p-mb-0">
      <span class="p-float-label">
        <input pInputText 
              id="rule" name="rule"
              class="p-inputtext-sm"
              [(ngModel)]="rosterType.rosterTypeRule" />
        <label for="rule">Rule</label>
      </span>
    </div>

    <div class="p-field p-col-12 p-md-12 p-mb-0">
      <span class="p-float-label">
        <textarea pInputTextarea class="p-inputtext-sm"
          id="desc"
          name="desc" 
          rows="6"
          [(ngModel)]="rosterType.rosterTypeDescription"></textarea>
        <label for="desc">Description</label>
      </span>
    </div>
  </div> 

  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button p-button-raised" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button p-button-raised p-button-outlined" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>